export const LIST_BENEFITS = [
  { text: "Flexible options to meet your needs" },
  { text: "2 years no claims discount for first time buyers" },
  { text: "Guaranteed repairs on Buildings Insurance claims" },
];

export const LANDLORD_LIST_BENEFITS = [
  { text: "Two years no claims discount for first time landlords" },
  { text: "Covered for malicious damage or vandalism by tenants " },
  { text: "Personalise your policy with optional rent protection" },
];

export const HOME_TYPE_OF_INSURANCE = [
  {
    text: "What type of home insurance do I need?",
    description:
      "You may choose to add optional extras to your policy to give you even more protection. Adding home emergency cover or bicycle cover to your home insurance can be cheaper than getting them separately.",
  },
];

export const LANDLORD_TYPE_OF_INSURANCE = {
  title: "What type of Landlord’s Insurance do I need?",
  description:
    "It's not just a rental property it's an investment for your future. You may choose to cover your property only or cover both your property and the contents within it.",
};

export const LIST_COVERED = [
  { text: "Fire damage" },
  { text: "Floods and storms" },
  { text: "Burglary and vandalism" },
  { text: "Burst pipes and escape of water" },
  { text: "Subsidence and heave" },
];

export const LIST_NOT_COVERED = [
  { text: "Wear and tear" },
  { text: "Negligence" },
  { text: "Lack of maintenance" },
  { text: "Incorrectly supplied information" },
  { text: "Unoccupied properties" },
];

export const INSURERS = [
  {
    name: "axa",
    url: "insurers-white/axa.png",
    alt: "axa",
  },
  {
    name: "covea",
    url: "insurers-white/covea.png",
    alt: "covea",
  },
  {
    name: "lv",
    url: "insurers-white/lv.png",
    alt: "lv",
  },
  {
    name: "rsa",
    url: "insurers-white/rsa.png",
    alt: "rsa",
  },
  {
    name: "ukgeneral",
    url: "insurers-white/ukgeneral.png",
    alt: "ukgeneral",
  },
  {
    name: "zurich",
    url: "insurers-white/zurich.png",
    alt: "zurich",
  },
  {
    name: "prestige",
    url: "insurers-white/prestige.png",
    alt: "prestige",
  },
];

export const LANDLORD_INSURERS = [
  {
    name: "axa",
    url: "insurers-white/axa.png",
    alt: "axa",
  },
  {
    name: "lv",
    url: "insurers-white/lv.png",
    alt: "lv",
  },
  {
    name: "rsa",
    url: "insurers-white/rsa.png",
    alt: "rsa",
  },
  {
    name: "ukgeneral",
    url: "insurers-white/ukgeneral.png",
    alt: "ukgeneral",
  },
  {
    name: "arkel",
    url: "insurers-white/arkel.png",
    alt: "arkel",
  },
];

export const TYPE_INSURANCES = [
  {
    title: "Buildings cover",
    description:
      "<p>As a homeowner or soon-to-be homeowner, it's important that you're covered against the unexpected.</p> <p>Getting the right buildings insurance is vital to protect not just your building, but yourself, your family, and home from a variety of situations. It's much more than bricks and mortar; it's the place you call home.</p>",
    icon: "buildings.svg",
  },
  {
    title: "Contents cover",
    description:
      "<p>Your belongings make a house a home. In partnership with a carefully selected group of the UK's best known insurers we strive to offer flexible contents insurance.</p><p> Each insurer is chosen to help us offer insurance for a wide range of properties at competitive prices.</p>",
    icon: "contents.svg",
  },
  {
    title: "Buildings & contents",
    description:
      "<p>If you'd like a combination of both Buildings and Contents Insurance you can protect your home inside and out with a range of options that let you decide how and what you pay for.</p>",
    icon: "buildingscontents.svg",
  },
];

export const LANDLORD_TYPE_INSURANCES = [
  {
    title: "Buildings & contents",
    description:
      "<p>If you'd like a combination of both Buildings and Contents Insurance, you can protect your property inside and out.</p> <p>We have a wide range of options that let you decide what you want to pay for and how you want to pay.</p>",
    icon: "buildingscontents.svg",
  },
  {
    title: "Buildings",
    description:
      "<p>As a landlord, it's important that you're covered against the unexpected.</p> <p>Getting the right buildings insurance is vital to ensure you are protecting not just your property, but  yourself and your tenants from a variety of situations.</p>",
    icon: "buildings.svg",
  },
];

export const ADD_ONS = [
  {
    title: "Home emergency cover",
    description:
      "24-hour access to approved tradespeople for when a home emergency arises. Call out charges and parts & labour costs are covered up to a maximum value.",
    icon: "home-emergency-2.png",
  },
  {
    title: "Legal expenses cover",
    description:
      "Our family legal protection offers you legal cover on a range of unforeseen circumstances such as employment law, property disputes and personal injury.",
    icon: "legal-expenses-2.png",
  },
  {
    title: "Accidental damage cover",
    description:
      "Designed for extra peace of mind in case of mishaps in the home such as hammering a nail through a pipe when hanging a picture or spilling red wine on the carpet.",
    icon: "accidental-damage.png",
  },
  {
    title: "Personal possessions cover",
    description:
      "Cover for accidental loss or damage to items usually worn or carried, like jewellery or mobile phones both in the UK and abroad.",
    icon: "personal-possessions.png",
  },
];

export const LANDLORD_ADD_ONS = [
  {
    title: "Accidental damage <br> for buildings & contents",
    description:
      "Buildings and contents cover is available to buy together or separately if needed. Protect your building and your contents from unexpected mishaps.",
    icon: "accidental-damage.png",
  },
  {
    title: "Landlord's emergency support",
    description:
      "Landlord's emergency cover provides a 24-hour service with access to approved tradesmen to resolve a range of emergencies. For example, it can help if the tenants found themselves completely locked out of the property, or after a complete failure of the heating or electrics in the property.",
    icon: "home-emergency-2.png",
  },
  {
    title: "Legal expenses for landlords",
    description:
      "Our legal expenses cover has been designed to protect landlords during legal disputes arising from renting out the property, such as property disputes, tenant eviction, and tax protection.",
    icon: "legal-expenses-2.png",
  },
  {
    title: "Rent protection",
    description:
      "Rent protection is there to make sure you don't experience a loss of income if your tenant stops paying the rent.",
    icon: "rent-protection.png",
  },
];

export const WHY_CHOOSE = [
  {
    title: "We're friendly",
    description:
      "Relationships are important to us so we aim to be friendly and approachable at all times.",
    icon: "friendly.jpg",
  },
  {
    title: "We're charming",
    description:
      "We respect our customers and their opinions. Whenever we talk to you we aim to be personable and engaging because you're important to us.",
    icon: "charming.jpg",
  },
  {
    title: "We're big",
    description:
      "We're a market leader and take our responsibilities seriously. We're confident about the difference we can make.",
    icon: "big.jpg",
  },
  {
    title: "We're flexible",
    description:
      "We're big, but not so big that we can't adapt and change. We constantly ask what we could do better and what should we try.",
    icon: "flexible.jpg",
  },
  {
    title: "We're surprising",
    description:
      "We aren't like other insurance companies and we don't want to be. We challenge the norms and stretch ourselves.",
    icon: "surprising.jpg",
  },
  {
    title: "We're premium",
    description:
      "We always take an intelligent approach which enables us to offer exceptional products and services.",
    icon: "premium.jpg",
  },
];

export const HOME_LINK = {
  FAQS: "https://paymentshield.helpshift.com/hc/en/7-d2c/",
  TWITTER: "http://twitter.com/paymentshield",
  CONTACT_US: "https://my.paymentshield.co.uk/contact-us",
};

export const LANDLORD_LINK = {
  FAQS: "https://paymentshield.helpshift.com/hc/app/8-d2c--landlord/",
};

export const POLICY_DOCUMENT = [
  {
    title: "Policy Booklet",
    subtitle: "PDF (437KB)",
    description:
      "Download the latest version of our Home Insurance policy booklet. This includes full information about what you are and aren't covered for.",
    fileName: "00755_hi_pnl_ps_017_090921-(1).pdf",
  },
  {
    title: "Policy Summary",
    subtitle: "PDF (141KB)",
    description:
      "Download the latest version of our Home Insurance policy summary. This provides an overview of the cover available.",
    fileName: "bc-ipid-013---017.pdf",
  },
];

export const LANDLORD_POLICY_DOCUMENT = [
  {
    title: "Policy Booklet",
    subtitle: "PDF (433KB)",
    description:
      "Download the latest version of our Landlord’s Insurance policy booklet. This includes full information about what you are and aren't covered for.",
    code: "terms",
    name: "PolicyBooklet",
    fileName: "Policy Booklet.pdf",
    isDownloading: false,
  },
  {
    title: "Policy Summary",
    subtitle: "PDF (108KB)",
    description:
      "Download the latest version of our Landlord’s Insurance policy summary. This provides an overview of the cover available.",
    code: "ipid",
    name: "PolicySummary",
    fileName: "Policy Summary.pdf",
    isDownloading: false,
  },
];

export const LANDLORD_INSURANCE_COVER_DESCRIPTION =
  "The exact level of cover you’ll get will depend on your chosen insurance policy. Typically, most landlord's insurance policies will offer similar types of protection, while most will also have certain exclusions.";

export const LANDLORD_ADDITIONAL_COVER_DESCRIPTION =
  "You may choose to add optional extras to your policy to give you even more protection. Adding landlord’s emergency cover or accidental damage cover to your landlord’s insurance can be cheaper than getting them separately.";
